import React from 'react';
import { CheckCircle2, Star } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

export const PackagesSection = ({ t }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="packages" className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.packages.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold">
            {t.packages.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.packages && t.packages.items && t.packages.items.length > 0 && (
            <>
              {t.packages.items[0] && (
                <Card className="bg-stone-800 border border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105 relative overflow-hidden">
                  <CardHeader className="text-center pb-8 pt-8">
                    <CardTitle className="text-3xl text-orange-500 mb-2">{t.packages.items[0].name}</CardTitle>
                    <CardDescription className="text-gray-300 text-lg mb-4">{t.packages.items[0].duration}</CardDescription>
                    <div className="flex items-baseline justify-center">
                      <span className="text-5xl font-bold text-white">${t.packages.items[0].price}</span>
                      <span className="text-gray-400 ml-2">/pers</span>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    <ul className="space-y-3">
                      {t.packages.items[0].features && t.packages.items[0].features[0] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[0].features[0]}</span></li>}
                      {t.packages.items[0].features && t.packages.items[0].features[1] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[0].features[1]}</span></li>}
                      {t.packages.items[0].features && t.packages.items[0].features[2] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[0].features[2]}</span></li>}
                      {t.packages.items[0].features && t.packages.items[0].features[3] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[0].features[3]}</span></li>}
                      {t.packages.items[0].features && t.packages.items[0].features[4] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[0].features[4]}</span></li>}
                    </ul>
                    <Button onClick={scrollToContact} className="w-full py-6 text-lg font-semibold transition-all duration-300 bg-stone-700 hover:bg-orange-500 text-white">Réserver Ce Forfait</Button>
                  </CardContent>
                </Card>
              )}
              
              {t.packages.items[1] && (
                <Card className="bg-stone-800 border border-orange-500 shadow-xl shadow-orange-500/20 transition-all duration-300 hover:scale-105 relative overflow-hidden">
                  <div className="absolute top-0 right-0">
                    <Badge className="bg-orange-500 text-white rounded-none rounded-bl-lg px-4 py-2"><Star className="h-4 w-4 mr-1 fill-current" />Populaire</Badge>
                  </div>
                  <CardHeader className="text-center pb-8 pt-8">
                    <CardTitle className="text-3xl text-orange-500 mb-2">{t.packages.items[1].name}</CardTitle>
                    <CardDescription className="text-gray-300 text-lg mb-4">{t.packages.items[1].duration}</CardDescription>
                    <div className="flex items-baseline justify-center">
                      <span className="text-5xl font-bold text-white">${t.packages.items[1].price}</span>
                      <span className="text-gray-400 ml-2">/pers</span>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    <ul className="space-y-3">
                      {t.packages.items[1].features && t.packages.items[1].features[0] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[0]}</span></li>}
                      {t.packages.items[1].features && t.packages.items[1].features[1] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[1]}</span></li>}
                      {t.packages.items[1].features && t.packages.items[1].features[2] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[2]}</span></li>}
                      {t.packages.items[1].features && t.packages.items[1].features[3] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[3]}</span></li>}
                      {t.packages.items[1].features && t.packages.items[1].features[4] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[4]}</span></li>}
                      {t.packages.items[1].features && t.packages.items[1].features[5] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[1].features[5]}</span></li>}
                    </ul>
                    {t.packages.chaletMin && (
                      <p className="text-xs text-gray-400 italic text-center">{t.packages.chaletMin}</p>
                    )}
                    <Button onClick={scrollToContact} className="w-full py-6 text-lg font-semibold transition-all duration-300 bg-orange-500 hover:bg-orange-600 text-white">Réserver Ce Forfait</Button>
                  </CardContent>
                </Card>
              )}
              
              {t.packages.items[2] && (
                <Card className="bg-stone-800 border border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105 relative overflow-hidden">
                  {t.packages.items[2].spotsLeft && (
                    <div className="absolute top-0 right-0">
                      <Badge data-testid="vip-spots-left-badge" className="bg-red-600 text-white rounded-none rounded-bl-lg px-4 py-2 animate-pulse">{t.packages.items[2].spotsLeft}</Badge>
                    </div>
                  )}
                  <CardHeader className="text-center pb-8 pt-8">
                    <CardTitle className="text-3xl text-orange-500 mb-2">{t.packages.items[2].name}</CardTitle>
                    <CardDescription className="text-gray-300 text-lg mb-4">{t.packages.items[2].duration}</CardDescription>
                    {t.packages.items[2].spotsLeft && (
                      <p className="text-red-500 font-bold text-sm mb-2">🔥 {t.packages.items[2].spotsLeft}</p>
                    )}
                    <div className="flex items-baseline justify-center">
                      <span className="text-5xl font-bold text-white">${t.packages.items[2].price}</span>
                      <span className="text-gray-400 ml-2">/pers</span>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    <ul className="space-y-3">
                      {t.packages.items[2].features && t.packages.items[2].features[0] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[0]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[1] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[1]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[2] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[2]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[3] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[3]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[4] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[4]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[5] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[5]}</span></li>}
                      {t.packages.items[2].features && t.packages.items[2].features[6] && <li className="flex items-start text-gray-300"><CheckCircle2 className="h-5 w-5 text-orange-500 mr-3 flex-shrink-0 mt-0.5" /><span>{t.packages.items[2].features[6]}</span></li>}
                    </ul>
                    <Button onClick={scrollToContact} className="w-full py-6 text-lg font-semibold transition-all duration-300 bg-stone-700 hover:bg-orange-500 text-white">Réserver Ce Forfait</Button>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>

        <div className="mt-12 text-center text-gray-400 text-sm space-y-2">
          <p className="text-green-500 font-bold text-lg">✅ TAXES INCLUSES dans tous les prix cette année - Spécial 2026!</p>
          <p>* Permis de chasse non inclus.</p>
          <p className="text-orange-500 font-bold text-lg mt-4">
            💰 30% de dépôt à la réservation de votre séjour
          </p>
          {t.packages.note && (
            <p className="text-orange-500 font-semibold mt-4">
              📢 {t.packages.note}
            </p>
          )}
          {t.packages.guidePrice && (
            <p className="text-xs text-gray-400 italic mt-1">
              {t.packages.guidePrice}
            </p>
          )}
          {t.packages.fishingGuide && (
            <p className="text-orange-500 font-semibold">
              🎣 {t.packages.fishingGuide}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
